import { combineReducers } from 'redux';

import { payProReducer } from './payPro';

export const healthReducer = combineReducers({
    payPro: payProReducer,
});
